import { useIsMobile } from '@sravni/react-utils';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { useAppSelector } from 'shared/lib';

import { availableBanksSelector, calcIdSelector, isBentoRankingModelSelector } from 'entities/offers';
import { useChannel } from 'entities/siteSettings/lib';

import { sendCalculationThunk } from './sendCalculationThunk';

export const useSendLoansCalculationData = () => {
  const dispatch = useDispatch();
  const isMobile = useIsMobile();
  const calcId = useAppSelector(calcIdSelector);
  const isBentoRankingModel = useAppSelector(isBentoRankingModelSelector);
  const availableBanks = useAppSelector(availableBanksSelector);
  const channel = useChannel();
  const [isCalculationSent, setIsCalculationSent] = useState(false);

  const sendCalculation = useCallback(async () => {
    await dispatch(
      sendCalculationThunk({
        sourceUrl: window.location.href,
        deviceType: isMobile ? 'mobile' : 'desktop',
        calcId,
        isBentoRankingModel,
        availableBanks,
        channel,
      }),
    );

    setIsCalculationSent(true);
  }, [dispatch, isMobile, calcId, isBentoRankingModel, availableBanks, channel]);

  useEffect(() => {
    if (calcId) {
      sendCalculation();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [calcId]);

  return { isCalculationSent };
};
